import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { Submissions } from "../../../Component/Model/Dto/VerificationAgency/IntegrationProcess/Submissions";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import { StringDateTimeHelper } from "../../../Component/Model/helpers";

interface PendingScorecardSubmissionRow {
    scorecardName: string,
    registrationName: string;
    clientName: string;
    status: string;
    createdDate: string;
    actions: ActionType[];
}

export interface PendingScorecardSubmissionTable {
    columns: Array<TableColumn>;
    rows: Array<PendingScorecardSubmissionRow>;
}

export function PendingScorecardSubmissionMapper(dataObject: Submissions.SubmissionSearchResult[], handleDelete: (id: number) => void, handleAcceptOrReject: (id: number) => void): PendingScorecardSubmissionTable {
    const columns = [
        { Header: 'Scorecard Name', accessor: 'scorecardName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Registration Name', accessor: 'registrationName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Date & Time Submitted', accessor: 'createdDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Client User', accessor: 'clientName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Submission Status', accessor: 'status', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];
    if (dataObject !== undefined && dataObject.length > 0) {
        const rows: PendingScorecardSubmissionRow[] = dataObject.map((item: Submissions.SubmissionSearchResult) => ({
            scorecardName: item.scorecardName,
            registrationName: item.registrationName,
            clientName: item.clientName,
            status: item.status,
            createdDate: StringDateTimeHelper(item.createdDate.toString()),
            actions: [
                {
                    key: item.id.toString(),
                    label: 'Accept/Reject',
                    action: () => {
                        handleAcceptOrReject(item.id);
                    },
                    icon: {
                        color: 'info',
                        name: 'rule'
                    }
                }
            ]
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}

interface AcceptedScorecardSubmissionRow {
    scorecardName: string,
    registrationName: string;
    clientName: string;
    vaName: string;
    status: string;
    createdDate: string;
    acceptanceDate: string;
    actions?: ActionType[];
}

export interface AcceptedScorecardSubmissionTable {
    columns: Array<TableColumn>;
    rows: Array<AcceptedScorecardSubmissionRow>;
}

export function AcceptedScorecardSubmissionMapper(dataObject: Submissions.SubmissionSearchResult[]): AcceptedScorecardSubmissionTable {
    const columns = [
        { Header: 'Scorecard Name', accessor: 'scorecardName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Registration Name', accessor: 'registrationName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Date & Time Submitted', accessor: 'createdDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Client User', accessor: 'clientName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Submission Status', accessor: 'status', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Date & Time Accepted', accessor: 'acceptanceDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Verification Agency User', accessor: 'vaName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    ];
    if (dataObject !== undefined && dataObject.length > 0) {
        const rows: AcceptedScorecardSubmissionRow[] = dataObject.map((item: Submissions.SubmissionSearchResult) => ({
            scorecardName: item.scorecardName,
            registrationName: item.registrationName,
            clientName: item.clientName,
            vaName: item.vaName,
            status: item.status,
            createdDate: StringDateTimeHelper(item.createdDate.toString()),
            acceptanceDate: StringDateTimeHelper(item.acceptanceDate.toString()),
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}


interface RejectedScorecardSubmissionRow {
    scorecardName: string,
    registrationName: string;
    clientName: string;
    vaName: string;
    status: string;
    createdDate: string;
    actions?: ActionType[];
}

export interface RejectedScorecardSubmissionTable {
    columns: Array<TableColumn>;
    rows: Array<RejectedScorecardSubmissionRow>;
}

export function RejectedScorecardSubmissionMapper(dataObject: Submissions.SubmissionSearchResult[]): RejectedScorecardSubmissionTable {
    const columns = [
        { Header: 'Scorecard Name', accessor: 'scorecardName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Registration Name', accessor: 'registrationName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Date & Time Submitted', accessor: 'createdDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Client User', accessor: 'clientName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Submission Status', accessor: 'status', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Verification Agency User', accessor: 'vaName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    ];
    if (dataObject !== undefined && dataObject.length > 0) {
        const rows: RejectedScorecardSubmissionRow[] = dataObject.map((item: Submissions.SubmissionSearchResult) => ({
            scorecardName: item.scorecardName,
            registrationName: item.registrationName,
            clientName: item.clientName,
            vaName: item.vaName,
            status: item.status,
            createdDate: StringDateTimeHelper(item.createdDate.toString()),
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}